export const EN_SINTONIA_LOGO_SRC =
  'https://files.tnonetwork.com/shows/logo/ensintoniacontusalud.png';
export const EN_SINTONIA_COVER_SRC =
  'https://files.tnonetwork.com/shows/cover/ensintoniacontusalud.jpg';
export const GRECIA_ANDREINA_ANCHOR_SRC =
  'https://files.tnonetwork.com/users/profile/greciagonzalez.jpg';
